module.exports = __webpack_public_path__ + "img/dos-a.f2ac497d.png";